/**
 * 垂直移动动画
 */
import fvAnimation from "./fvAnimation"
export default class fvVerticalMove extends fvAnimation {
    constructor(shape){
        super(shape,"fvVerticalMove");
        this.sizeFunction = AsyncFunction("return " + this.expression);
        this.bottomLeft = AsyncFunction("return " + this.bottomLeft);
        this.topRight = AsyncFunction("return " + this.topRight);
        this.bottomLeftMove = AsyncFunction("return " + this.bottomLeftMove);
        this.topRightMove = AsyncFunction("return " + this.topRightMove);
        // 初始化y值保存
        this.y = shape.y;
        this.originalSizeY = shape.originalSize.y;

        // 打组初始化各个组件y保存
        for (var p in this.shape.subObjects) {
            if(this.shape.subObjects[p] && this.shape.subObjects[p].$){
                this.shape.subObjects[p].y = this.shape.subObjects[p].$.y;
            }
        };
    }

    async run(canvas,value){
      // if(value == false) return;
        var size = await this.executionScript(this.sizeFunction);
        var bottomLeftValue = await this.executionScript(this.bottomLeft);
        var topRightValue = await this.executionScript(this.topRight);
        var bottomLeftMoveValue = await this.executionScript(this.bottomLeftMove);
        var topRightMoveValue = await this.executionScript(this.topRightMove);
        var viewNum = (parseFloat(topRightMoveValue) - parseFloat(bottomLeftMoveValue)) * (size - parseFloat(bottomLeftValue)) / (parseFloat(topRightValue) - parseFloat(bottomLeftValue)) + parseFloat(bottomLeftMoveValue) ;
        // 点不存在不移动
        if(size === -9999){
          return;
        }
        if(size <= bottomLeftValue || size <= topRightValue ){
          if(bottomLeftMoveValue < topRightMoveValue){
            this.shape.y = parseFloat(this.y) - viewNum;
            // 组件内部计算偏移不进入
            if(this.shape.fctype.indexOf('Obj') >= 0){
              if(this.shape.magnification){
                this.shape.cy = this.y + this.originalSizeY - viewNum/this.shape.magnification.y;
              }else{
                this.shape.cy = this.y + this.originalSizeY - viewNum/this.shape.getMagnification().y;
              }
            }else{
              //图片精灵添加
              canvas.domStyle.top = this.y + viewNum+"px";
            }
          }else if(bottomLeftMoveValue == topRightMoveValue){
            this.shape.y;
            if(this.shape.domNode){
              this.shape.domNode.style.top;
            }
          }else{
            this.shape.y = parseFloat(this.y) + viewNum;
            if(this.shape.fctype.indexOf('Obj') >= 0){
              if(this.shape.magnification){
                this.shape.cy = this.y + viewNum/this.shape.magnification.y;
              }else{
                this.shape.cy = this.y + viewNum/this.shape.getMagnification().y;
              }
            }else{
              //图片精灵添加
              canvas.domStyle.top = this.y + viewNum+"px";
            }
          }
        }
    }

    async runEx(canvas){
        var size = await this.executionScript(this.sizeFunction);
        var bottomLeftValue = await this.executionScript(this.bottomLeft);
        var topRightValue = await this.executionScript(this.topRight);
        var bottomLeftMoveValue = await this.executionScript(this.bottomLeftMove);
        var topRightMoveValue = await this.executionScript(this.topRightMove);
        var viewNum = (parseFloat(topRightMoveValue) - parseFloat(bottomLeftMoveValue)) * (size - parseFloat(bottomLeftValue)) / (parseFloat(topRightValue) - parseFloat(bottomLeftValue)) + parseFloat(bottomLeftMoveValue) ;
         // 点不存在不移动
         if(size === -9999){
           return;
         }
        if(size <= bottomLeftValue || size <= topRightValue ){
          if(bottomLeftMoveValue < topRightMoveValue){
            this.shape.y = parseFloat(this.y) - viewNum;
            this.shape.originalSize.y = this.originalSizeY - viewNum/this.shape.getMagnification().y;
            // this.shape.$el.style.top = parseFloat(this.y) - viewNum;
            for (var p in this.shape.subObjects) {
              if(this.shape.subObjects[p] && this.shape.subObjects[p].$){
                this.shape.subObjects[p].$.originalSize.y = this.originalSizeY - viewNum/this.shape.getMagnification().y;
                this.shape.subObjects[p].$.y =  parseFloat(this.shape.subObjects[p].y) - viewNum;
              }
            };
          }else if(bottomLeftMoveValue == topRightMoveValue){
            this.shape.y;
          }else{
            this.shape.y = parseFloat(this.y) + viewNum;
            // this.shape.$el.style.top = parseFloat(this.y) - viewNum;
            this.shape.originalSize.y = this.originalSizeY + viewNum/this.shape.getMagnification().y;
            for (var p in this.shape.subObjects) {
              if(this.shape.subObjects[p]  && this.shape.subObjects[p].$){
                this.shape.subObjects[p].$.originalSize.y = this.originalSizeY + viewNum/this.shape.getMagnification().y;
                this.shape.subObjects[p].$.y = parseFloat(this.y) + viewNum;
              }
            };
          }
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvVerticalMove.js